// extracted by mini-css-extract-plugin
module.exports = {"allFilters":"Filter_allFilters__2lue4","score":"Filter_score__3bWSA","recipe":"Filter_recipe__MLb7u","diets":"Filter_diets__2LB9H"};